export default __webpack_public_path__ + "static/media/day-9.0204f9af.jpg";